import React from "react";

function BannerBtns() {
	return (
		<div className="bannerButtons">
			<button id="learnBtn">Learn More</button>
			<button id="signBtn">Sign Up</button>
		</div>
	);
}

export default BannerBtns;
